import { Modal } from "react-bootstrap";
import useFlow from "../hooks/useFlow";
import { toast } from "react-toastify";

export default function EventNotificationModal() {
  const {
    showEventNotificationModal,
    setShowEventNotificationModal,
    setShowMapResourceModal,
    voteForEvent,
  } = useFlow();

  const handleClose = () => {
    setShowEventNotificationModal(false);
    setShowMapResourceModal(true);
  };

  const handleVote = () => {
    voteForEvent();
    toast.success("Thank you for your support! We appreciate it!", {
      autoClose: 5000,
      position: "top-center",
    });
    handleClose();
    setShowMapResourceModal(true);
  };

  return (
    <>
      <Modal
        show={showEventNotificationModal}
        onHide={handleClose}
        centered
        size="lg"
        className="best-of-atx-modal"
      >
        <Modal.Body className="p-4">
          <div className="row">
            <div className="col-5">
              <img
                src="/best_of_atx2.png"
                alt="Best of ATX"
                className="img-fluid rounded-4"
              />
            </div>

            {/* Right Section - Content and buttons */}
            <div className="col-7 d-flex flex-column justify-content-center align-items-center">
              <div>
                <h4 className="mb-2 text-center fw-light">
                  Flow is nominated for <br />
                  <span>
                    <i>Austin Monthly&apos;s</i> Best Yoga!
                  </span>
                </h4>
                <h4 className="mb-4 text-center my-4 fw-bold">
                  Can we add your vote?
                </h4>
              </div>

              <div className="d-flex flex-column justify-content-center">
                <button
                  className="btn btn-lg btn-primary my-4 p-3 px-5 w-auto"
                  data-testid="event-vote-yes-btn"
                  onClick={handleVote}
                  style={{
                    backgroundColor: "#20B2AA",
                    borderColor: "#20B2AA",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Yes! I love Flow
                </button>

                <div className="text-center">
                  <button
                    className="btn btn-link p-0 my-4"
                    data-testid="event-vote-no-btn"
                    onClick={handleClose}
                    style={{
                      color: "#777",
                      textDecoration: "none",
                      fontSize: "16px",
                    }}
                  >
                    no thanks
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="text-center mt-3">
                <small className="text-muted fw-normal">
                  We&apos;ll submit your vote using the information on your
                  account
                </small>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
